import { BREADCRUMBS_CLICK, BREADCRUMBS_CLICK_DETAIL } from '~~/constants/googleTagManager';

export const buildClickBreadcrumbsTags = ({
  categoryName,
  categoryPath,
  categoryLevel,
  source,
}: {
  categoryName: string;
  categoryPath: string;
  categoryLevel: number;
  source: string;
}) => ({
  event: BREADCRUMBS_CLICK,
  event_info: {
    detail: BREADCRUMBS_CLICK_DETAIL,
    category_name: categoryName,
    category_path: categoryPath,
    category_level: categoryLevel,
    source,
  },
});
